import type { JSX, ReactNode } from 'react';

export interface EntryListProps {
  /** The accessible name of the list, which is also how E2E finds it. */
  readonly label: string;
  readonly children: ReactNode;
}

/** A list of records: one column on a phone, never a table that scrolls sideways. */
export function EntryList({ label, children }: EntryListProps): JSX.Element {
  return (
    <ul aria-label={label} className="divide-y divide-border">
      {children}
    </ul>
  );
}

export interface EntryProps {
  /** The first line: what this record is. */
  readonly lead: ReactNode;
  /** Everything that explains it, in one or more lines. */
  readonly meta?: ReactNode;
  /** The amount, state or buttons the record ends with. */
  readonly trailing?: ReactNode;
}

export function Entry({ lead, meta, trailing }: EntryProps): JSX.Element {
  return (
    <li className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2 py-3">
      <div className="flex min-w-0 flex-col gap-1">
        <span className="font-medium">{lead}</span>
        {meta}
      </div>
      {trailing}
    </li>
  );
}
